package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SaveW500Rounded: ImageVector
    get() {
        if (_saveW500Rounded != null) {
            return _saveW500Rounded!!
        }
        _saveW500Rounded = Builder(name = "SaveW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(202.87f, 848.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-554.26f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                lineTo(645.8f, 111.87f)
                quadToRelative(18.22f, 0.0f, 34.72f, 6.84f)
                quadToRelative(16.5f, 6.83f, 29.18f, 19.51f)
                lineTo(821.78f, 250.3f)
                quadToRelative(12.68f, 12.68f, 19.51f, 29.18f)
                quadToRelative(6.84f, 16.5f, 6.84f, 34.72f)
                verticalLineToRelative(442.93f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(202.87f, 848.13f)
                close()
                moveTo(757.13f, 315.2f)
                lineTo(644.8f, 202.87f)
                lineTo(202.87f, 202.87f)
                verticalLineToRelative(554.26f)
                horizontalLineToRelative(554.26f)
                lineTo(757.13f, 315.2f)
                close()
                moveTo(565.0f, 682.13f)
                quadToRelative(35.0f, -35.0f, 35.0f, -85.0f)
                reflectiveQuadToRelative(-35.0f, -85.0f)
                quadToRelative(-35.0f, -35.0f, -85.0f, -35.0f)
                reflectiveQuadToRelative(-85.0f, 35.0f)
                quadToRelative(-35.0f, 35.0f, -35.0f, 85.0f)
                reflectiveQuadToRelative(35.0f, 85.0f)
                quadToRelative(35.0f, 35.0f, 85.0f, 35.0f)
                reflectiveQuadToRelative(85.0f, -35.0f)
                close()
                moveTo(288.37f, 402.87f)
                horizontalLineToRelative(269.0f)
                quadToRelative(19.15f, 0.0f, 32.33f, -13.17f)
                quadToRelative(13.17f, -13.18f, 13.17f, -32.33f)
                verticalLineToRelative(-69.0f)
                quadToRelative(0.0f, -19.15f, -13.17f, -32.33f)
                quadToRelative(-13.18f, -13.17f, -32.33f, -13.17f)
                horizontalLineToRelative(-269.0f)
                quadToRelative(-19.15f, 0.0f, -32.33f, 13.17f)
                quadToRelative(-13.17f, 13.18f, -13.17f, 32.33f)
                verticalLineToRelative(69.0f)
                quadToRelative(0.0f, 19.15f, 13.17f, 32.33f)
                quadToRelative(13.18f, 13.17f, 32.33f, 13.17f)
                close()
                moveTo(202.87f, 315.2f)
                verticalLineToRelative(441.93f)
                verticalLineToRelative(-554.26f)
                verticalLineToRelative(112.33f)
                close()
            }
        }
        .build()
        return _saveW500Rounded!!
    }

private var _saveW500Rounded: ImageVector? = null
